/* Page to page effect: the next page opens in a circle from the spot that was clicked (only where the browser supports page-to-page view
   transitions, so the old page stays visible until the new one is ready). */
(() => {
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Firefox always gets the plain honey wipe below, even if it later learns page-to-page view transitions, so both never run at once */
  const firefox = /\bFirefox\//.test(navigator.userAgent);
  const native = !firefox && 'onpagereveal' in window;
  if (firefox) ['pageswap', 'pagereveal'].forEach((t) => window.addEventListener(t, (e) => { try { if (e.viewTransition) e.viewTransition.skipTransition(); } catch (err) {} }));
  const root = document.documentElement;
  let store = null;
  try { store = window.sessionStorage; } catch (e) {}
  const read = (k) => { try { return store ? store.getItem(k) : null; } catch (e) { return null; } };
  const write = (k, v) => { try { if (store) { if (v === null) store.removeItem(k); else store.setItem(k, v); } } catch (e) {} };
  const setOrigin = (xy) => { if (!xy) return; const [x, y] = xy.split(','); root.style.setProperty('--vx', x + '%'); root.style.setProperty('--vy', y + '%'); };
  /* page arrived through the fallback wipe: start covered, then reveal */
  if (!reduce && !native && read('bmx-wipe')) {
    setOrigin(read('bmx-xy'));
    root.classList.add('bmx-enter');
    write('bmx-wipe', null);
    let opened = false;
    const open = () => {
      if (opened) return;
      opened = true;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        root.classList.add('bmx-go');
        setTimeout(() => root.classList.remove('bmx-enter', 'bmx-go'), 760);
      }));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open, { once: true }); else open();
    setTimeout(open, 1200);
    setTimeout(() => root.classList.remove('bmx-enter', 'bmx-go'), 3000);
  }
  const internal = (a, e) => {
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download') || a.getAttribute('href') === null) return false;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin) return false;
    if (u.pathname === location.pathname && u.search === location.search) return false;
    if (/^\/(cart|account|checkouts?)(\/|$)/.test(u.pathname) && a.closest('form')) return false;
    return u;
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    const u = internal(a, e);
    if (!u) return;
    write('bmx-xy', Math.round(e.clientX / innerWidth * 100) + ',' + Math.round(e.clientY / innerHeight * 100));
    /* browsers without page-to-page view transitions (Firefox, older Safari) simply open the next page: covering the page while the next
       one loads left a honey colored screen with a small hole on slower connections */
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) root.classList.remove('bmx-leave', 'bmx-enter', 'bmx-go'); });
  /* buttons inside a slider or picker must move the whole component, not the button that was clicked */
  document.addEventListener('alpine:init', () => {
    document.querySelectorAll('.bmx-sl[x-data], .bmx-fill[x-data], .bmx-t5[x-data]').forEach((el) => {
      const s = el.getAttribute('x-data');
      if (s.includes('this.$el')) el.setAttribute('x-data', s.split('this.$el').join('this.$root'));
    });
  });

  /* the wavy edge under each picker (fruit sticks and the like, and the Tiny Bites / Dubai pickers) takes the one color painted at the very
     top of the section that follows */
  const solid = (el) => { const c = getComputedStyle(el).backgroundColor; return c && c !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(c) ? c : ''; };
  const topColor = (wrap) => {
    const box = wrap.getBoundingClientRect();
    let el = wrap; let color = solid(wrap);
    for (let i = 0; i < 8 && el; i++) {
      const kids = [...el.children].filter((k) => { const r = k.getBoundingClientRect(); return r.height > 2 && Math.abs(r.top - box.top) < 3 && r.width > box.width * .9; });
      el = kids[0];
      if (el && solid(el)) color = solid(el);
    }
    return color;
  };
  const nextBg = () => document.querySelectorAll('section.bmx-sticks, section.bmx-fill.bmx-fill--nostrip').forEach((sec) => {
    let n = sec.closest('.shopify-section');
    n = n && n.nextElementSibling;
    while (n && !n.offsetHeight) n = n.nextElementSibling;
    const c = n ? topColor(n) : '';
    if (c && c !== solid(sec)) { sec.style.setProperty('--bmx-next', c); sec.classList.remove('bmx-no-wave'); } else sec.classList.add('bmx-no-wave');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nextBg); else nextBg();
  window.addEventListener('load', nextBg);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((t) => document.addEventListener(t, () => setTimeout(nextBg, 60)));
  document.addEventListener('click', (e) => { if (e.target.closest('section.bmx-sticks .bmx-chip, section.bmx-sticks button, section.bmx-fill .bmx-chip')) setTimeout(nextBg, 700); });

  window.addEventListener('pagereveal', (e) => {
    if (e.viewTransition) setOrigin(read('bmx-xy'));
  });

  /* Shopping safety.
     1. A teleport whose target is missing makes Alpine stop watching the page, so the cart drawer that loads later never shows. Drop those teleports before Alpine starts. */
  document.addEventListener('alpine:init', () => {
    document.querySelectorAll('template[x-teleport]').forEach((t) => {
      let ok = false;
      try { ok = !!document.querySelector(t.getAttribute('x-teleport')); } catch (e) {}
      if (!ok) t.remove();
    });
  });
  /* 2. Load the cart drawer soon after the page loads, so it is ready before the first Add to cart tap.
     3. If the drawer still cannot show, unlock the page and open the cart page instead of leaving the screen stuck. */
  const cartUrl = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  const guardCart = () => {
    const mc = window.Alpine && Alpine.store('xMiniCart');
    if (!mc || mc.bmxGuard) return;
    const open = mc.openCart;
    mc.bmxGuard = true;
    mc.openCart = function () {
      const had = !!document.getElementById('CartDrawer');
      open.apply(this, arguments);
      if (/\/cart\/?$/.test(location.pathname)) return;
      let waited = 0;
      const check = () => {
        if (!this.open) return;
        const d = document.getElementById('CartDrawer');
        if (d && d._x_dataStack && getComputedStyle(d).display !== 'none') { if (!had) this.reLoad(); return; }
        waited += 250;
        if (waited < (d ? 1500 : 5000)) { setTimeout(check, 250); return; }
        this.open = false;
        try { Alpine.store('xPopup').close(); } catch (e) {}
        location.href = cartUrl();
      };
      setTimeout(check, 250);
    };
  };
  const warm = (n) => {
    if (!(window.Alpine && document.body && document.body._x_dataStack)) { if (n < 40) setTimeout(() => warm(n + 1), 250); return; }
    guardCart();
    try {
      const d = Alpine.$data(document.body);
      if (d && d.runDispatch) { d.runDispatch = false; window.dispatchEvent(new CustomEvent('init-run')); }
    } catch (e) {}
  };
  if (document.readyState === 'complete') setTimeout(() => warm(0), 600); else window.addEventListener('load', () => setTimeout(() => warm(0), 600));

  /* 4. Add to cart on product cards adds in place and opens the cart drawer. Without the drawer, or if the request fails, the form posts the normal way and the cart page opens. */
  const inner = (html, sel) => {
    if (typeof getSectionInnerHTML === 'function') return getSectionInnerHTML(html, sel);
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    return el ? el.innerHTML : '';
  };
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest && e.target.closest('form.bmx-card__cta, form.bmx-t5__cta');
    if (!form || e.defaultPrevented) return;
    const A = window.Alpine;
    const mc = A && A.store('xMiniCart');
    const helper = A && A.store('xCartHelper');
    if (!mc || !helper || !document.getElementById('CartDrawer') || !document.body._x_dataStack) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const old = form.parentElement && form.parentElement.querySelector('.bmx-card__err');
    if (old) old.remove();
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    let data = null;
    try {
      const sections = helper.getSectionsToRender();
      const fd = new FormData(form);
      fd.append('sections', sections.map((s) => s.id));
      fd.append('sections_url', location.pathname);
      const res = await fetch((window.Eurus && Eurus.cart_add_url) || form.action, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      data = await res.json();
      if (data && data.status) {
        const p = document.createElement('p');
        p.className = 'bmx-card__err';
        p.setAttribute('role', 'alert');
        p.textContent = data.description || data.message || 'This item could not be added.';
        form.insertAdjacentElement('afterend', p);
        return;
      }
      sections.forEach((s) => {
        const el = document.querySelector(s.selector);
        if (el && data.sections && data.sections[s.id]) el.innerHTML = inner(data.sections[s.id], s.selector);
      });
      mc.openCart();
      try { helper.currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML, 10) || 0; } catch (err) {}
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (err) {
      if (!data) form.submit(); else location.href = cartUrl();
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });

  /* Photo tiles. Each product photo sits on a tile painted in the photo's own background color, so the photo's edge never shows.
     White backgrounds become the cream wafer tile, busy photos fill the tile edge to edge, cut-outs keep the theme tile.
     It runs on the product page gallery, its thumbnails, the cart drawer and the cart page, so new products need no setup. */
  const tileJobs = new Map();
  const tileKey = (src) => { try { return new URL(src, location.href).pathname; } catch (e) { return src; } };
  const tileSample = (src) => { try { const u = new URL(src, location.href); u.searchParams.set('width', '64'); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.href; } catch (e) { return ''; } };
  const tileRead = (src) => {
    const k = tileKey(src);
    if (tileJobs.has(k)) return tileJobs.get(k);
    const job = new Promise((done) => {
      const url = tileSample(src);
      if (!url || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(url)) { done(null); return; }
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = () => {
        try {
          const w = 32, h = Math.max(8, Math.round(32 * im.naturalHeight / im.naturalWidth));
          const c = document.createElement('canvas'); c.width = w; c.height = h;
          const x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, w, h);
          const d = x.getImageData(0, 0, w, h).data;
          const at = (i, j) => { const o = (j * w + i) * 4; return [d[o], d[o + 1], d[o + 2], d[o + 3]]; };
          const spots = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2], [w >> 1, 1], [w >> 1, h - 2], [1, h >> 1], [w - 2, h >> 1]].map(([i, j]) => at(i, j));
          if (spots.some((p) => p[3] < 200)) { done({ t: 'cut' }); return; }
          const avg = [0, 1, 2].map((n) => Math.round(spots.reduce((a, p) => a + p[n], 0) / spots.length));
          const spread = Math.max(...spots.map((p) => Math.abs(p[0] - avg[0]) + Math.abs(p[1] - avg[1]) + Math.abs(p[2] - avg[2])));
          if (spread > 36) done({ t: 'fill' });
          else if (Math.min(...avg) > 240) done({ t: 'white' });
          else done({ t: 'flat', c: 'rgb(' + avg.join(',') + ')' });
        } catch (e) { done(null); }
      };
      im.onerror = () => done(null);
      im.src = url;
    });
    tileJobs.set(k, job);
    return job;
  };
  const TILE_IMG = '[id^="product-media-"] .splide__slide img, .product-media-container .x-thumbnail img, #CartDrawer img.image-hover, #main-cart-items img.image-hover';
  const tileOf = (img) => img.closest('.splide__slide, .x-thumbnail') || img.parentElement;
  const paintTile = (img) => {
    const src = img.getAttribute('src') || '';
    if (!src || img.dataset.bmxTile === src) return;
    img.dataset.bmxTile = src;
    tileRead(src).then((r) => {
      if (!r) return;
      const t = tileOf(img);
      if (!t) return;
      t.classList.remove('bmx-pt--cut', 'bmx-pt--fill', 'bmx-pt--white', 'bmx-pt--flat');
      t.classList.add('bmx-pt', 'bmx-pt--' + r.t);
      if (r.c) t.style.setProperty('--pt-bg', r.c); else t.style.removeProperty('--pt-bg');
    });
  };
  let tileTimer = 0;
  const scanTiles = () => { tileTimer = 0; document.querySelectorAll(TILE_IMG).forEach(paintTile); };
  const queueTiles = () => { if (!tileTimer) tileTimer = setTimeout(scanTiles, 120); };
  const startTiles = () => {
    scanTiles();
    new MutationObserver(queueTiles).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    document.addEventListener('eurus:cart:items-changed', queueTiles);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTiles); else startTiles();
})();

/* Smoother pages: a section's animations pause while it is off screen, and a picker can fade its new background color in on its own layer
   (the page under it is not repainted on every frame of the fade). */
(() => {
  window.bmxTint = (el, color) => {
    if (!el || !color || !el.animate) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let o = el.querySelector(':scope > .bmx-bgfx');
    if (!o) { o = document.createElement('span'); o.className = 'bmx-bgfx'; o.setAttribute('aria-hidden', 'true'); el.prepend(o); }
    o.style.backgroundColor = color;
    if (o._a) o._a.cancel();
    o._a = o.animate([{ opacity: 0.45 }, { opacity: 1, offset: 0.85 }, { opacity: 1 }], { duration: 280, easing: 'ease-out' });
  };
  if (!('IntersectionObserver' in window)) return;
  const start = () => {
    const io = new IntersectionObserver((es) => { for (const e of es) e.target.classList.toggle('bmx-off', !e.isIntersecting); }, { rootMargin: '160px 0px' });
    document.querySelectorAll('#MainContent .shopify-section, .shopify-section-group-footer-group').forEach((s) => {
      if (s.querySelector('.bmx-floaters') || s.classList.contains('bmx-section-floaters')) return;
      io.observe(s);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* The colored band at the top of a collection or product page (Home / Shop / ...) takes the color of the flavor picked in the first picker
   below it (on a product page: the color of that product's own flavor, set once). Pickers call bmxBand(their root, color, deep); deep mixes a little chocolate in, so a band over a picker of the same color
   still reads as its own band. The text stays white while white reads well on the new color (as on the red Fruit Sticks band), otherwise it
   turns chocolate. */
(() => {
  const band = () => document.querySelector('#MainContent .bmx-col-hero--slim');
  const first = () => document.querySelector('#MainContent .bmx-fill, #MainContent .bmx-sticks, #MainContent .bmx-picker');
  const rgb = (c) => {
    const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(c).trim());
    if (m) { let h = m[1]; if (h.length === 3) h = h.split('').map((x) => x + x).join(''); return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)); }
    const p = document.createElement('i'); p.style.color = c; p.style.display = 'none'; document.body.appendChild(p);
    const v = (getComputedStyle(p).color.match(/[\d.]+/g) || []).map(Number); p.remove();
    return v.length >= 3 ? v.slice(0, 3) : null;
  };
  const lum = (c) => { const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }; return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]); };
  window.bmxBand = (src, color, deep, init) => {
    const b = band(), f = first();
    if (!b || !color || (src && f && src !== f)) return;
    if (!init && b.classList.contains('bmx-col-hero--pdp')) return;
    let c = rgb(color);
    if (!c) return;
    if (deep) c = c.map((v, i) => Math.round(v * (1 - deep) + [43, 19, 9][i] * deep));
    const bg = 'rgb(' + c.join(', ') + ')';
    if (b.dataset.tone === bg) return;
    if (b.dataset.tone && window.bmxTint) window.bmxTint(b, bg);
    b.dataset.tone = bg;
    const L = lum(c);
    b.style.background = bg;
    b.style.color = (1.05 / (L + 0.05)) >= 3.5 ? '#ffffff' : '#2b1309';
  };
  const start = () => {
    const f = first();
    if (!f || !band()) return;
    const cs = getComputedStyle(f);
    if (f.classList.contains('bmx-fill')) window.bmxBand(f, cs.getPropertyValue('--bf-bg'), 0.2, true);
    else window.bmxBand(f, cs.getPropertyValue('--accent'), 0, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
